<div
  class="layout"
  [style.color]="fontColor"
  [class.has-label]="labelEnabled"
  [class.no-injected-search-or-filters]="!injectSearch"
  [class.has-filter-builder]="hasFilterBuilder"
  [class.has-filters]="hasFilters"
  [class.has-search]="hasSearch"
  [class.has-buttons]="hasButtons"
  [class.mobile]="viewportMode === 'mobile'"
>
  @if (labelEnabled) {
    <label class="label" [ngStyle]="labelStyles">
      @if (labelIcon) {
        <mat-icon [svgIcon]="labelIcon" [ngStyle]="iconStyles" />
      }
      <span>{{ labelText }}</span>
    </label>
  }
  @if (hasFilters || hasSearch || hasFilterBuilder) {
    <div class="filters">
      @if (slots?.slotNodesData?.searchAndFilters) {
        <div
          class="filters-slot"
          [style.margin]="slotPaddingCompensation"
          [blazeSlotNode]="slots?.slotNodesData?.searchAndFilters"
          [blazeSlotNodeForceExpand]="shouldForceExpand"
        >
          <ng-container
            *ngTemplateOutlet="
              slots?.templates?.searchAndFilters || null;
              context: {
                elementContext: {
                  forceExpandElements: shouldForceExpand,
                },
              }
            "
          />
        </div>
      }
      <ng-container
        *ngTemplateOutlet="
          hasFilterBuilder ? filterBuilderTriggerTpl : null;
          context: { fullWidth: viewportMode === 'mobile' }
        "
      />
    </div>
  }
  <div #buttons class="buttons" [class.!hidden]="!hasButtons">
    @if (addButtonEnabled) {
      <button
        blazeClickable
        (click)="addButtonClick.emit($event)"
        [disabled]="addButtonBlocked"
        [blazeTooltip]="addButtonLabel || 'Add new row'"
        [ngClass]="addButtonCssClasses || []"
        blazeIconButton="bat"
        blazeIconButtonSize="xl"
        class="efh-action-btn"
        data-cy="FilterHeader:addRow"
        type="button"
      >
        <span class="icon">
          <mat-icon svgIcon="icon_add_16" />
        </span>
        {{ addButtonLabel }}
      </button>
    }
    <ng-content />
  </div>
</div>
